
import { Component, Vue, Prop } from 'vue-property-decorator';
import { updateBusiness } from '@/api/user';

@Component({
})
export default class extends Vue {
  @Prop({ required: true }) private formData!: any;

  private form = {
    originalPassword: '',
  }

  private rules = {
    userPassword: [
      { required: true, message: '패스워드를 입력하세요.', trigger: ['change', 'blur'] },
      {
        min: 8,
        max: 20,
        message: '패스워드는 최소 8자, 최대 20자입니다.',
        trigger: ['change', 'blur'],
      },
    ],
    originalPassword: [
      { required: true, message: '기존 패스워드를 입력하세요.', trigger: ['change', 'blur'] },
      {
        min: 8,
        max: 20,
        message: '패스워드는 최소 8자, 최대 20자입니다.',
        trigger: ['change', 'blur'],
      },
    ],
  }

  private handleClickSave() {
    (this.$refs.form as any).validate((valid: boolean) => {
      if (valid) {
        this.$confirm('정말 사업자 정보를 저장하시겠습니까?', '사업자 정보 저장', {
          confirmButtonText: '저장',
          cancelButtonText: '취소',
          type: 'info',
        }).then(() => {
          updateBusiness(this.formData, this.form.originalPassword).then((res) => {
            this.$message.success('정보가 수정되었습니다.');
            this.$emit('success');
          }).catch((error) => {
            this.$message.error(error.response.data.message);
          });
        });
      }
    });
  }
}
